import { useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";
import { OPS_ENDPOINTS } from "@constants/endpoints";

// The publisher's KYC record — status, per-document details and the window countdown.
// `loaded` separates "still fetching" from "fetched and failed" for the tab's empty state.
const usePublisherKycRecord = (publisherId) => {
    const { axiosInstance, loading } = useAxios({ base: "ops", initialLoader: true });
    const [record, setRecord] = useState(null);
    const [loaded, setLoaded] = useState(false);

    const fetchRecord = async () => {
        try {
            const res = await axiosInstance.get(OPS_ENDPOINTS.PUBLISHER_KYC(publisherId));
            const result = res.data || res;
            setRecord(result.data || result);
        } catch {
            setRecord(null);
        } finally {
            setLoaded(true);
        }
    };

    useEffect(() => {
        if (publisherId) fetchRecord();
    }, [publisherId]); // eslint-disable-line react-hooks/exhaustive-deps

    return { record, loading: loading || !loaded, refetch: fetchRecord };
};

export default usePublisherKycRecord;
